import image from 'shared/assets/images/integrationsSliders/insightly/insightly.png'
import { LINK_INSIGHTLY_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const insightly: IntegrationDetailsData = {
  subheadline: 'Strengthen your CRM and project management with messaging intelligence.',
  overview:
    'Connect Salesmsg with Insightly to streamline your workflow and keep your CRM and project management platform up to date. When you engage with contacts through Salesmsg, relevant information flows to Insightly, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and CRM workflows',
  ],
  images: [image],
  docs: LINK_INSIGHTLY_INTEGRATION_GUIDE,
}
